import { OrbitActionLink } from './types';

const ROUTES: Record<string, (id: number) => string> = {
  rule: id => `/p/rules/show/${id}`,
  audience: id => `/p/audiences/show/${id}`,
  campaign: id => `/p/campaigns/show/${id}`,
  reward: id => `/p/rewards/show/${id}`,
  loyalty_program: id => `/p/loyalty/show/${id}`
};

/** Every `link.entity` the dashboard can open; v1 sends `rule` only, the rest follow the design. */
export const ORBIT_LINK_ENTITIES = Object.keys(ROUTES);

/** The dashboard page for a step's record; `null` for no link or an entity with no page here. */
export const orbitRecordRoute = (link: OrbitActionLink | null | undefined): string | null => {
  if (link === null || link === undefined) {
    return null;
  }

  const route = ROUTES[link.entity];
  return route === undefined ? null : route(link.id);
};
